<div class="w-100">
  <ng-container *ngIf="!coupon || setNewCoupon; else usedCoupon">
    <form [formGroup]="form">
      <div class="input-discount">
        <input class="form-control mr-2" placeholder="Enter discount code" formControlName="coupon" />
        <button class="btn btn-info px-4" [disabled]="inProgress || !form.valid" (click)="apply()">Apply</button>
      </div>
      <control-messages [control]="couponControl"></control-messages>
    </form>
  </ng-container>
</div>

<ng-template #usedCoupon>
  <div class="d-flex flex-row align-items-center">
    <p class="mb-0 mr-2">You're using <strong [innerText]="coupon"></strong> code</p>
    <button class="btn btn-info px-4" (click)="editCoupon()">Edit</button>
  </div>
</ng-template>
